import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Video from 'Component/Video';
import Curso from 'Interface/Cursos';
import { useRecuperarAulaQuery, useRecuperarCursosQuery } from 'Service';
import { useAppSelector } from 'Store';

const Assistir = (): React.ReactElement => {
  const navegacao = useNavigate();
  const { urlAula, urlLivro, unidadeDeAprendizagem } = useAppSelector((estado) => estado.aula);
  const { slug = '', id = 0 } = useParams();

  const { data: { cursos: [curso] } = { cursos: [{} as Curso] } } =
    useRecuperarCursosQuery({
      finder: 'slug',
      contain: ['Categorias', 'Modulos.Aulas'],
      options: { slug: { slug: slug } },
    });
  const { data: { aula } = {} } = useRecuperarAulaQuery(id);

  useEffect(() => {
    if (!urlAula) {
      navegacao(`/estudar/curso/${slug}/aula/${id}`);
    }
  }, [id, navegacao, slug, urlAula]);

  return (
    <div className="animate__animated animate__fadeIn mh-100 d-flex align-items-center">
      <Video
        titulo={aula?.titulo}
        aoFechar={() => navegacao(`/estudar/curso/${curso.slug}`)}
        url={urlAula}
        livro={urlLivro}
        unidadeDeAprendizagem={unidadeDeAprendizagem}
      />
    </div>
  );
};

export default Assistir;
